import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcConvenience(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.304 18.5 6.163-7.428h-2.624L14.696 5.5l-6.163 7.428h2.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }));
}
var IcConvenience = createNolIcon(/*#__PURE__*/forwardRef(SvgIcConvenience));

export { IcConvenience as I };
